import { render, staticRenderFns } from "./IconBibliography.vue?vue&type=template&id=57032936&"
import script from "./IconBibliography.vue?vue&type=script&lang=ts&"
export * from "./IconBibliography.vue?vue&type=script&lang=ts&"
import style0 from "./IconBibliography.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports